import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import PrivateRoute from '../components/PrivateRoute'
import Dashboard from '../pages/Dashboard'
import Login from '../pages/Login'
import NotFound from '../pages/NotFound'
import RoutesAlmoxarifado from './almoxarifado/Routes'
import RoutesManutencao from './manutencao/Routes'
import RoutesAluguel from './aluguel/Routes'
import ApplicationSelection from '../pages/ApplicationSelection'
import RoutesAdmin from './admin/Routes'
import RoutesFaturamento from './faturamento/Routes'
import { useApplication } from '../hooks/useApplication'
import ApplicationEnum from '../enums/application-enum'

const normalizeRole = (role) => String(role || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR')
const isExactGestor = (user) => normalizeRole(user?.role) === 'gestor'

// Componente que decide para onde o usuário vai
const SmartDashboardRedirect = () => {
  const { user, getDashboardConfig } = useAuth()
  const { selectedApplication } = useApplication()

  // Se o usuário ainda não foi carregado, manda para o login (segurança)
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Pega a configuração baseada no cargo do usuário (ex: { module: 'aluguel', view: 'sac' })
  const roleDashboard = getDashboardConfig(user)
  const isGestor = isExactGestor(user)
  const gestorModule = {
    [ApplicationEnum.ALUGUEL]: { module: 'aluguel', view: 'gestor' },
    [ApplicationEnum.ALMOXARIFADO]: { module: 'almoxarifado' },
    [ApplicationEnum.MANUTENÇÃO]: { module: 'manutencao', view: 'gestor' },
    [ApplicationEnum.FATURAMENTO]: { module: 'aluguel', view: 'financeiro' },
  }
  const { module, view } = isGestor && gestorModule[selectedApplication?.id]
    ? gestorModule[selectedApplication.id]
    : selectedApplication?.id === ApplicationEnum.FATURAMENTO
      ? { module: 'aluguel', view: 'financeiro' }
      : roleDashboard

  // Monta a URL final. 
  // Se tiver view: /dashboard/aluguel?view=sac
  // Se não tiver view: /dashboard/almoxarifado
  const targetUrl = view 
    ? `/dashboard/${module}?view=${view}` 
    : `/dashboard/${module}`

  return <Navigate to={targetUrl} replace />
}

const GestorAdminRoute = ({ element: Element }) => {
  const { user } = useAuth()
  return isExactGestor(user) ? <Navigate to="/dashboard" replace /> : Element
}

const AppRoutesContent = () => {
  // Função auxiliar para transformar os objetos de rotas em componentes <Route />
  const renderRoutes = (routesObj) => {
    return Object.values(routesObj).flatMap((categoryArray) =>
      categoryArray.map((route) => (
        <Route key={route.path} path={route.path} element={route.path.startsWith('/aluguel/usuarios') || route.path.startsWith('/aluguel/organizacoes') || route.path.startsWith('/aluguel/cargos') || route.path.includes('/logs') ? <GestorAdminRoute element={route.element} /> : route.element} />
      ))
    )
  }

  const applicationRoutes = [
    {
      path: '/aplicacoes',
      element: <PrivateRoute element={ApplicationSelection} />,
    },
  ]

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<SmartDashboardRedirect />} />
      <Route path="/dashboard/:module" element={<PrivateRoute element={Dashboard} />} />

      {applicationRoutes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}

      {renderRoutes(RoutesAdmin)}
      {renderRoutes(RoutesAluguel)}
      {renderRoutes(RoutesAlmoxarifado)}
      {renderRoutes(RoutesManutencao)}
      {renderRoutes(RoutesFaturamento)}

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutesContent
